/// <reference path="../_references.ts"/>

module App.PriceGuide {
	import Appointment = App.Appointments.Appointment;
	import Department = App.Appointments.Department;
	import OfficeService = App.Utils.OfficeService;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import Tag = App.Appointments.Tag;
	import TagType = App.Appointments.TagType;
	import Template = App.WorkOrderTemplate.Template;
	import TitleBarService = App.Helpers.TitleBarService;
	import UserSession = App.User.UserSession;
	import WorkOrderTemplateService = App.WorkOrderTemplate.WorkOrderTemplateService;
	import ToastService = App.Utils.ToastService;

	export class PriceGuideController {
		public static fromTemplateSubCat = {
			id: 0,
			name: 'From Template'
		};

		public static fromTemplateCat = {
			id: 0,
			name: 'From Template',
			sub_categories: [PriceGuideController.fromTemplateSubCat]
		};

		appointment: Appointment = null;

		displayFilters: boolean = false;
		displaySorts: boolean = false;
		displayFavorites: boolean = false;
		fromOffice: boolean = false;
		isFetching: boolean = false;

		departments: Department[] = [];
		categories: ServiceCategory[] = [];
		subCategories: SubCategory[] = [];
		tagTypes: TagType[];

		products: Product[] = [];
		expandMap: {[id: number]: boolean} = {};

		customProduct: Product = null;

		searchText: string = null;
		deleteTemplateMode: boolean = false;
		isDeleting: boolean = false;

		selectedDepartment: Department = null;
		selectedCategory: ServiceCategory = null;
		selectedSubCategory: SubCategory = null;
		selectedTags: Tag[] = [];
		selectedSortBy: 'priceLowToHigh' | 'priceHighToLow' | 'nameAscending' | 'nameDescending' = null;
		onlyName: boolean = false;

		packageId: number = null;

		pageSize: number = 25;
		page: number = 1;
		count: number = 0;
		maxPage: number = 1;

		isSaving: boolean = false;

		selectedProducts: {
			[key: string]: Product
		} = {};

		accordions: {
			[key: string]: boolean
		} = {};

		packageCount: number = 0;

		selectedTemplates: number[] = [];
		templates: Template[] = [];
		showTemplates: boolean = true;

		inProgress: boolean = false;
		modifiedPackage: boolean = false;
		collectsTax: boolean = false;

		templatePermission: boolean;
		productsPermission: boolean;
		deleteTemplatePermission: boolean;

		static $inject: string[] = [
			'$q', '$state', '$stateParams', 'SelectedAppointment', 'TitleBarService', 'ProductService',
			'PermissionService', 'WorkOrderTemplateService', 'UserSession', 'OfficeService', '$document',
			'ToastService', 'ModalService',
		];

		constructor(
			protected $q: ng.IQService,
			private $state: ng.ui.IStateService,
			private $stateParams: ng.ui.IStateParamsService,
			private SelectedAppointment: SelectedAppointment,
			private TitleBarService: TitleBarService,
			private ProductService: ProductService,
			private PermissionService: App.Helpers.PermissionService,
			private WorkOrderTemplateService: WorkOrderTemplateService,
			private UserSession: UserSession,
			private OfficeService: OfficeService,
			private $document: ng.IDocumentService,
			protected ToastService: ToastService,
			protected ModalService: any
		) {
			let vm = this;

			TitleBarService.set('Appointment');

			vm.packageId = $stateParams.packageId;

			if(vm.packageId) {
				vm.showTemplates = false;
			}

			vm.accordions.department = true;

			OfficeService.getAppointment().then(response => {
				vm.fromOffice = true;
				vm.setAppointment(response.data);
			}).catch(() => {
				SelectedAppointment.getAppointment().then((appointment) => {
					vm.setAppointment(appointment);
				});
			});

			this.templatePermission = PermissionService.hasAnyPermission([
				'web.field.price-guide.templates.list',
				'web.office.service-requests.service-request.tech-view'
			]);
			this.productsPermission = PermissionService.hasAnyPermission([
				'web.field.price-guide.products.list',
				'web.office.service-requests.service-request.tech-view'
			]);
			this.deleteTemplatePermission = PermissionService.hasAnyPermission([
				'web.field.price-guide.templates.delete',
				'web.office.service-requests.service-request.tech-view'
			]);

			this.showTemplates = this.templatePermission;

			ProductService.getDepartments().then((response) => {
				vm.departments = response.data;

				// This shouldn't be necessary, but for some reason it is.  Causes the switch to appear after navigation - otherwise only appears on refresh.
				componentHandler.upgradeElement(this.$document[0].getElementById('only-name-switch'));
			});

			ProductService.getCollectsTax('current')
				.then((resp) => this.collectsTax = resp.data.collect)
				.then(() => this.upgradeForm());
		}

		setAppointment(appointment: Appointment): void {
			const vm = this;

			vm.appointment = appointment;

			vm.packageCount = vm.appointment.service_request.packages.length;

			vm.getTemplates();
			vm.getProductsList(true);
		}

		resetSearch(): void {
			this.searchText = '';
			this.performSearch();
		}

		performSearch(): void {
			if (this.showTemplates) {
				this.getTemplates();
			} else {
				this.getProductsList();
			}
		}

		goTop(): void {
			document.getElementById('top-scroll').scrollIntoView({ block: 'start',  behavior: 'smooth' });
		}

		getProductsList(showCustom = false): void {
			if (!this.productsPermission) {
				return;
			}

			let vm = this,
				params: SearchParams = {};

			vm.isFetching = true;

			if(vm.searchText && vm.searchText.length >= 3) {
				params.search = vm.searchText;
			}

			if(vm.selectedDepartment) {
				params.department = vm.selectedDepartment.id;
			}

			if (vm.selectedCategory) {
				if (vm.selectedCategory.id === 0) {
					params.from_template = 1;
					params.category = 'null';
					params.sub_category = 'null';
				} else {
					params.category = vm.selectedCategory.id;
					if (vm.selectedSubCategory) {
						params.sub_category = vm.selectedSubCategory.id;
					}
				}
			}

			if(vm.selectedTags.length) {
				params.tag = vm.selectedTags.map(tag => tag.id).join(',');
			}

			switch(vm.selectedSortBy) {
				case 'priceLowToHigh':
					params.orderBy = 'material_cost';
					params.sort = 'asc';
					break;
				case 'priceHighToLow':
					params.orderBy = 'material_cost';
					params.sort = 'desc';
					break;
				case 'nameAscending':
					params.orderBy = 'name';
					params.sort = 'asc';
					break;
				case 'nameDescending':
					params.orderBy = 'material_cost';
					params.sort = 'desc';
					break;
				default:
					break;
			}

			if(vm.displayFavorites) {
				params.favorites = true;
			}

			if(showCustom) {
				params.custom = true;
			}

			if(vm.onlyName) {
				params.only_name = true;
			}

			if(Object.keys(params).length === 0) {
				const newProducts: Product[] = [];
				for (let i in Object.keys(vm.products)) {
					if (vm.isProductSelected(vm.products[i])) {
						newProducts.push(angular.copy(vm.products[i]));
					}
				}
				vm.products = newProducts;
				vm.expandMap = {};
				vm.isFetching = false;

				return;
			}

			if(Object.keys(vm.selectedProducts).length) {
				params.selected = Object.keys(vm.selectedProducts).map((key) => parseInt(key, 10)).join(',');
			}

			params.service_request = vm.appointment.service_request.id;

			params.page = this.page;
			params.size = this.pageSize;
			params.show_safe_tech_info = true;

			vm.ProductService.getProductList(params).then((response) => {
				let headers = response.headers();

				if (this.updatePageInfo(Number(headers.count))) {
					this.page = this.maxPage;
					return this.getProductsList();
				}

				vm.products = response.data;
				vm.expandMap = {};
			}, (response) => {
				vm.ToastService.showError('Unable to get products: ', response);
			}).finally(() => {
				vm.isFetching = false;
			});
		}

		setPage(page: number) {
			let newPage = Math.max(1, Math.min(this.maxPage, page));
			if (newPage !== this.page) {
				this.page = newPage;
				this.showTemplates ? this.getTemplates() : this.getProductsList();
			}
		}

		getItemCount() {
			if (this.count === 0) {
				return '0 - 0 of 0';
			}

			return Math.min(this.count, ((this.page - 1) * this.pageSize) + 1) + ' - ' + Math.min(this.count, this.pageSize * this.page) + ' of ' + this.count;
		}

		updatePageInfo(count: number) {
			this.count = count;
			this.maxPage = Math.max(1, Math.ceil(this.count / this.pageSize));

			return this.maxPage < this.page;
		}

		getDepartmentCategories(department: Department): void {
			let vm = this;

			vm.searchText = null;
			vm.displayFavorites = false;
			vm.selectedDepartment = department;
			vm.selectedCategory = null;
			vm.selectedSubCategory = null;
			vm.accordions.category = false;
			vm.accordions.subCategory = false;
			vm.categories = [];
			vm.subCategories = [];
			vm.selectedTags = [];

			vm.ProductService.getCategories(department.id).then((response) => {
				vm.categories = response.data || [];
				vm.categories.push(PriceGuideController.fromTemplateCat);
				vm.accordions.category = true;

				vm.getProductsList();
				vm.setTagList(department);
			});
		}

		setTagList(department: Department): void {
			const vm = this;

			vm.tagTypes = department.tag_types;

			vm.tagTypes.forEach(tagType => {
				vm.accordions[tagType.name + tagType.id] = true;
			});
		}

		selectTag(tag: Tag): void {
			const vm = this,
				index = vm.selectedTags.findIndex(selectedTag => selectedTag.id === tag.id);

			vm.searchText = null;
			vm.displayFavorites = false;
			if(index > -1) {
				vm.selectedTags.splice(index, 1);
			} else {
				vm.selectedTags.push(tag);
			}

			vm.getProductsList();
		}

		isTagSelected(tag: Tag): boolean {
			const vm = this;

			return vm.selectedTags.findIndex(selectedTag => selectedTag.id === tag.id) > -1;
		}

		setSubCategories(category: ServiceCategory): void {
			const vm = this;

			vm.searchText = null;
			vm.displayFavorites = false;
			vm.selectedCategory = category;
			vm.selectedSubCategory = null;
			vm.selectedTags = [];
			vm.accordions.subCategory = true;
			vm.subCategories = category.sub_categories;
			if (category.id === 0) {
				vm.selectedSubCategory = PriceGuideController.fromTemplateSubCat;
			}

			vm.getProductsList();
		}

		onSelectSubCategory(subCategory: SubCategory): void {
			const vm = this;

			vm.searchText = null;
			vm.selectedSubCategory = subCategory;
			vm.displayFavorites = false;
			vm.selectedTags = [];

			vm.getProductsList();
		}

		toggleFilters(): void {
			this.displayFilters = !this.displayFilters;
		}

		clearFilters(): void {
			const vm = this;

			vm.selectedDepartment = null;
			vm.selectedCategory = null;
			vm.selectedSubCategory = null;
			vm.categories = [];
			vm.subCategories = [];
			vm.tagTypes = [];
			vm.displayFavorites = false;
			vm.searchText = null;
			vm.selectedTags = [];
			vm.onlyName = false;

			const keys = Object.keys(vm.accordions);

			keys.forEach((key) => {
				vm.accordions[key] = false;
			});

			vm.accordions.department = true;

			vm.getProductsList();
		}

		removeFilter(type: 'department'|'category'|'subCategory' | 'tag', tag?: Tag): void {
			const vm = this;

			switch(type) {
				case 'subCategory':
					vm.selectedSubCategory = null;
					vm.getProductsList();
					break;
				case 'category':
					vm.selectedCategory = null;
					vm.selectedSubCategory = null;
					vm.getProductsList();
					break;
				case 'tag':
					const tagIndex = vm.selectedTags.findIndex(selectedTag => selectedTag.id === tag.id);
					if(tagIndex > -1) vm.selectedTags.splice(tagIndex, 1);
					break;
				default:
					vm.clearFilters();
			}
		}

		toggleSorts($event: ng.IAngularEvent): void {
			$event.stopPropagation();

			this.displaySorts = !this.displaySorts;
		}

		toggleFavorites(): void {
			this.displayFavorites = !this.displayFavorites;

			this.performSearch();
		}

		createPackage(): void {
			this.modifiedPackage = false;
			let vm = this,
				products = Object.keys(vm.selectedProducts).map((key) => {
					return {
						quantity: vm.selectedProducts[key].quantity,
						service_id: vm.selectedProducts[key].id
					};
				});

			vm.packageCount++;

			vm.ProductService.createPackage(vm.appointment.service_request.id, {
				name: null,
				code: null,
				services: products
			});
		}

		updatePackage(): void {
			this.modifiedPackage = false;
			let vm = this,
				products = Object.keys(vm.selectedProducts).map((key) => {
					return {
						quantity: vm.selectedProducts[key].quantity,
						service_id: vm.selectedProducts[key].id
					};
				});

			vm.isSaving = true;

			vm.ProductService.updatePackage(vm.appointment.service_request.id, {
				id: vm.packageId,
				services: products
			}).then(() => {
				vm.$state.go('zipSolutions.workOrder');
			});
		}

		toggleAccordion(key: string): void {
			const vm = this;

			if(angular.isUndefined(vm.accordions[key])) {
				vm.accordions[key] = false;
			}

			vm.accordions[key] = !vm.accordions[key];
		}

		toggleProductFavorite(product: Product): void {
			const vm = this;

			if(vm.isProductFavorite(product)) {
				vm.UserSession.removeFavorite(product.id);
			} else {
				vm.UserSession.addFavorite(product.id);
			}
		}

		isProductFavorite(product: Product): boolean {
			if (!this.UserSession.user) {
				return false;
			}

			return this.UserSession.user.favorites.indexOf(product.id) > -1;
		}

		hasSelectedProducts(): boolean {
			let vm = this;

			return Object.keys(vm.selectedProducts).length > 0;
		}

		selectProduct(product: Product, manual?: undefined | boolean): void {
			let vm = this;
			vm.modifiedPackage = true;
			const quantity = product.quantity;

			if(vm.isProductSelected(product) && ((angular.isUndefined(quantity) || quantity === 0 || quantity === null) || manual)) {
				delete vm.selectedProducts[product.id];
				product.quantity = null;
			} else {
				if(angular.isUndefined(quantity) || quantity === null) {
					product.quantity = 1;
				}

				vm.selectedProducts[product.id] = angular.copy(product);
			}
		}

		isProductSelected(product: Product): boolean {
			return angular.isDefined(this.selectedProducts[product.id]);
		}

		getQuantity(product: Product): void {
			const vm = this;

			if(vm.isProductSelected(product)) {
				product.quantity = vm.selectedProducts[product.id].quantity;
			}
		}

		upgradeForm(): void {
			const taxExemptElem = this.$document[0].getElementById('taxExempt');

			if (taxExemptElem) {
				componentHandler.upgradeElement(taxExemptElem.parentElement);
			}
		}

		editCustomProduct(): void {
			if (this.customProduct) {
				this.customProduct = null;
			} else {
				this.upgradeForm();
				this.customProduct = {
					id: null,
					name: null,
					tax_exempt: false,
					description: null,
					material_cost: null,
					service_department: null,
					labor_minutes: null,
					service_price_override: null,
					service_request_id: this.appointment.service_request.id
				};
			}
		}

		addCustomProduct(form: ng.IFormController): void {
			this.ProductService.createCustomProduct(this.customProduct).then((response) => {
				this.customProduct = null;

				this.products.unshift(response.data);
				this.selectProduct(response.data);

				form.$setPristine();
				form.$setUntouched();
			});
		}

		getTemplates() {
			if (this.templatePermission) {
				this.isFetching = true;

				this.WorkOrderTemplateService.fetchAll(
					this.appointment.service_request.id,
					this.searchText,
					this.displayFavorites ? true : null,
					this.pageSize,
					this.page
				).then((response) => {
					let headers = response.headers();

					if (this.updatePageInfo(Number(headers.count))) {
						this.page = this.maxPage;
						return this.getProductsList();
					}

					this.templates = response.data;
				}).finally(() => {
					this.isFetching = false;
				});
			}
		}

		toggleShowTemplates(show: boolean) {
			this.searchText = null;
			this.displayFavorites = false;
			this.deleteTemplateMode = false;
			this.showTemplates = show;
			this.pageSize = 25;
			this.page = 1;
			this.count = 0;
			this.maxPage = 1;
		}

		toggleDeleteMode() {
			if (this.deleteTemplatePermission) {
				this.deleteTemplateMode = !this.deleteTemplateMode;
				this.selectedTemplates = [];
			}
		}

		isBusy(): boolean {
			return this.isDeleting;
		}

		deleteTemplates() {
			if (this.deleteTemplatePermission) {
				this.isDeleting = true;

				const templates = this.templates.filter((template) => this.matchessTemplateSelected(template.id)),
					$q = this.$q,
					WorkOrderTemplateService = this.WorkOrderTemplateService;

				this.ModalService.showModal({
					controller: ['close', function($close: (result: any, delay?: number) => void) {
							this.isDone = false;
							this.close = (confirm: boolean) => {
								if (confirm) {
									this.isDone = true
									$q.all(
										templates.map((template) => WorkOrderTemplateService.delete(template.id, { quiet: true }))
									).finally(() => $close(confirm, 0));
								} else {
									$close(confirm, 0);
								}
							}
							this.templates = templates;
						}
					],
					controllerAs: 'modal',
					backdrop: 'static',
					templateUrl: 'html/price-guide/delete-templates-modal.tpl.html',
				}).then((modal) => {
					modal.close.then((confirm) => {
						if (confirm) {
							this.templates = this.templates.filter((template) => this.selectedTemplates.indexOf(template.id) === -1);
						}

						this.isDeleting = false;
						this.toggleDeleteMode();
					});
				}).catch(() => this.isDeleting = false);
			}
		}

		isTemplateSelected() {
			return this.selectedTemplates.length;
		}

		matchessTemplateSelected(id: number) {
			return this.selectedTemplates.indexOf(id) >= 0;
		}

		selectTemplate(id: number) {
			var index = this.selectedTemplates.indexOf(id);
			if (index >= 0) {
				this.selectedTemplates.splice(index, 1);
			} else {
				this.selectedTemplates.push(id);
			}
		}

		toggleTemplateFavorite(template: Template) {
			if(template.favorited) {
				this.WorkOrderTemplateService.removeFavorite(template.id).then(() => {
					template.favorited = false;
				});
			} else {
				this.WorkOrderTemplateService.addFavorite(template.id).then(() => {
					template.favorited = true;
				});
			}
		}

		toWorkorder() {
			if (this.fromOffice) {
				this.$state.go("zipSolutions.workOrder", this.$stateParams, { location: false });
			} else {
				this.$state.go("zipSolutions.workOrder");
			}
		}

		buildFromTemplate() {
			if(this.inProgress) {
				return;
			}

			if (this.selectedTemplates.length === 0) {
				this.toWorkorder();
				return;
			}

			this.inProgress = true;

			this.WorkOrderTemplateService.load(this.appointment.service_request.id, this.selectedTemplates.join(',')).then(() => {
				this.toWorkorder();
			}, () => {
				this.inProgress = false;
			});
		}

		continueWithPackages() {
			if(this.hasSelectedProducts() && this.modifiedPackage) {
				if(!confirm("You have products selected that have not yet been packaged.  Continue?")) {
					return;
				}
			}

			this.toWorkorder();
		}

	}
}
